import * as Yup from 'yup';
import createConfiguracionTurnosForm from './createConfiguracionTurnosFormModel';

const {
  formField: {
    name,
    cargo,
    turnos,
    TipoTurno,
    frecuencia,
    fechaInicioTurno
  }

} = createConfiguracionTurnosForm;


export default [

  Yup.object().shape({ 
       
    
    [name.name]: Yup.string().required(`${name.requiredErrorMsg}`),
    [cargo.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${cargo.requiredErrorMsg}`),
    [fechaInicioTurno.name]: Yup.string().required(`${fechaInicioTurno.requiredErrorMsg}`),
    [frecuencia.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${frecuencia.requiredErrorMsg}`),
    [turnos.name]: Yup.array()
    .min(1, `${turnos.requiredErrorMsg}`)
    .required(`${turnos.requiredErrorMsg}`),
    // [turnos.name]: Yup.object().shape({
    //   value: Yup.string().required(),
    //   label: Yup.string().required()
    // }).default(undefined) // 👈 
    // .required(`${turnos.requiredErrorMsg}`),
    [TipoTurno.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${TipoTurno.requiredErrorMsg}`),
    [fechaInicioTurno.name]: Yup.string().required(`${fechaInicioTurno.requiredErrorMsg}`)
    

    
    
    // [fechaInicioTurno.name]: Yup.object().shape({
    //   value: Yup.string().required(),
    //   label: Yup.string().required()
    // }).default(undefined) // 👈 
    // .required(`${fechaInicioTurno.requiredErrorMsg}`),
    // [fechaInicioTurno.name]: Yup.string().required(`${fechaInicioTurno.requiredErrorMsg}`),
    // [end_hour.name]: Yup.string().required(`${end_hour.requiredErrorMsg}`),
    // [tarifa.name]: Yup.number().required(`${tarifa.requiredErrorMsg}`),
    // [anio.name]: Yup.number().required(`${anio.requiredErrorMsg}`),

  })
  
];  

    